import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { get } from "lodash"
import featAnonymous from "../imgs/feat-anonymous.svg"
import arrowDropUp from "../imgs/arrow_drop_up.svg"
import arrowDropDown from "../imgs/arrow_drop_down.svg"

const TopSignOutMenu = styled.div`
  .signout-div-child-wrapper {
    min-width: 80px;
    padding: 18px 0;
  }

  .signout-div-child {
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
  }

  .signout-div-child-logo {
    cursor: pointer;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    user-select: none;
    transition: background-color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      box-shadow 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    overflow: visible;
  }

  .mdcl-child {
    position: relative;
    user-select: none;
    transition: color 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95),
      fill 0.25s cubic-bezier(0.8, 0.3, 0.45, 0.95);
    display: flex !important;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .mdcl-child-img {
    display: block;
  }

  .nav-child-dialog {
    position: absolute;
    top: 66px;
    width: 172px;
    border: 1px solid #f1f1f1;
    background: #ffffff;
    padding: 16px 0;
    box-shadow: 0px 12px 40px rgba(110, 133, 155, 0.12);
    transform: translateX(-10%);
  }
  .nav-child-dialog-inner {
    max-height: 500px;
    overflow-y: hidden;
    padding: 0 32px;
  }

  .column-title-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    .title {
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      color: #0e1616;
    }
    .subtitle {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      color: #0e1616;
    }
    .action-button {
      color: #667af4;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .button-text {
        line-height: 17px;
        margin-left: 5px;
      }
      .link {
        text-decoration: none;
        color: ${props => props.color};
        border-bottom: 1px solid #667af4;
      }
    }
  }
  .title-header {
    margin-bottom: 16px;
  }

  .user-action-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .link {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .mdcl-child-img {
      width: 24px;
      height: 24px;
      min-width: 16px;
      min-height: 16px;
      filter: grayscale(1);
      margin-right: 6px;
    }
  }

  .mdcl-child-img-arrow {
    width: 10px;
    height: 10px;
    margin-left: 6px;
  }
`

export const SignOutMenu = ({ authStore }) => {
  const navDialogRef = useRef(null)
  const [openNavDialog, setOpenNavDialog] = useState(false)
  const userId = get(authStore, "state.user.user_id", null)
  useEffect(() => {
    const handleClickOutside = event => {
      if (
        navDialogRef.current &&
        !navDialogRef.current.contains(event.target)
      ) {
        setOpenNavDialog(false)
      }
    }
    document.addEventListener("click", handleClickOutside, true)
    return () => {
      document.removeEventListener("click", handleClickOutside, true)
    }
  }, [])
  return (
    <TopSignOutMenu
      color={openNavDialog ? "#667af4" : "#9ba1aa"}
      ref={navDialogRef}
    >
      <div className="signout-div-child-wrapper">
        <div
          className="signout-div-child"
          onClick={() => {
            setOpenNavDialog(!openNavDialog)
          }}
        >
          <div className="signout-div-child-logo">
            <div className="mdcl-child">
              <div className="link">
                <img
                  className="mdcl-child-img"
                  src={featAnonymous}
                  alt="user-sign"
                />
                <p className="middle-div-child-para">{userId}</p>
                <img
                  className="mdcl-child-img-arrow"
                  src={openNavDialog ? arrowDropUp : arrowDropDown}
                  alt="arrow-sign"
                />
              </div>
            </div>
          </div>
        </div>
        {openNavDialog && (
          <div className="nav-child-dialog">
            <div className="nav-child-dialog-inner">
              <SignOutMenuContent authStore={authStore} />
            </div>
          </div>
        )}
      </div>
    </TopSignOutMenu>
  )
}

export const SignOutMenuContent = ({ authStore }) => {
  return (
    <div className="columns-wrapper">
      <div className="single-column">
        <div className="column-header">
          <div className="column-title-actions title-header">
            <div className="title">
              <a
                className="last-div-child"
                href="#log"
                onClick={e => {
                  authStore.logout()
                  e.preventDefault()
                }}
              >
                sign out
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
